import {
  IconButton,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
} from "@chakra-ui/react";
import { OrderResponseItem } from "@syla/shared/types/responses/OrderResponseItem";
import React, { memo, useMemo, useState } from "react";
import { MdInfoOutline } from "react-icons/md";
import { renderTransactionNeedsReviewItems } from "../transactionDrawer/transactionOverview/renderTransactionNeedsReviewItems";
import { TransactionsNeedsReviewList } from "./TransactionsNeedsReviewList";

type OrderNeedsReviewSummaryProps = {
  transactions: OrderResponseItem["transactions"];
};

export const OrderNeedsReviewSummary = memo(function OrderNeedsReviewSummary({
  transactions,
}: OrderNeedsReviewSummaryProps): React.ReactElement {
  const [hasOpened, setHasOpened] = useState(false);

  // the render is expensive, so only do it once the popover is opened
  const needsReviewItems = useMemo(() => {
    if (!hasOpened) {
      return [];
    }

    return renderTransactionNeedsReviewItems({ transactions });
  }, [hasOpened, transactions]);

  return (
    <Popover
      trigger="hover"
      isLazy
      lazyBehavior="unmount"
      onOpen={() => setHasOpened(true)}
    >
      <PopoverTrigger>
        <IconButton
          size="sm"
          fontSize="lg"
          variant="ghost"
          colorScheme="warning"
          color="warning.700"
          aria-label="Your items needing review"
          icon={<MdInfoOutline />}
        />
      </PopoverTrigger>

      <PopoverContent
        borderColor="warning.300"
        borderWidth="1px"
        borderRadius="0.5rem"
        bgColor="warning.25"
        padding="0.25rem"
      >
        <PopoverBody>
          <TransactionsNeedsReviewList items={needsReviewItems} />
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
});
